import React from 'react';
import { useDataLoader } from '@eogile/agrements-common/src/hooks/useDataLoader';
import { Card, CardContent, CardHeader, Stack, Table, TableBody, TableHead, TableRow } from '@mui/material';
import TableCell from '@eogile/agrements-common/src/components/table/TableCell';
import { FdjAgency } from '../common-types/direction/fdjDirectionTypes';
import ApiHelper, { pathWithQueryString } from '@eogile/agrements-common/src/api/apiHelper';
import SecondaryActionButton from '@eogile/agrements-common/src/components/buttons/SecondaryActionButton';
import { UploadDirectionCsvButton } from '@eogile/agrements-common/src/components/direction/UploadDirectionCsvButton';

/**
 * Component in charge of displaying the list of FDJ agencies.
 */
export const FdjDirectionAdminPage = () => {
  const { data, setData } = useDataLoader<FdjAgency[]>('/api/agencies');

  const refresh = async () => {
    setData(await ApiHelper.get('/api/agencies'));
  };

  const actionButtons = (
    <Stack direction="row" spacing={2} alignItems="center">
      <UploadDirectionCsvButton refreshData={refresh} />
      <SecondaryActionButton href={pathWithQueryString('/api/agencies/export')} label="Exporter" />
    </Stack>
  );

  return (
    <Card>
      <CardHeader action={actionButtons} title="Consultation des secteurs" />
      <CardContent>
        {data && (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Code</TableCell>
                <TableCell>Nom</TableCell>
                <TableCell>Direction Régionale</TableCell>
                <TableCell>Responsable</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Adresse</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((agency) => (
                <TableRow key={agency.id}>
                  <TableCell>{agency.code}</TableCell>
                  <TableCell>{agency.name}</TableCell>
                  <TableCell>{agency.regionalDirection.name}</TableCell>
                  <TableCell>{agency.managerName}</TableCell>
                  <TableCell>{agency.email}</TableCell>
                  <TableCell>
                    {agency.address1}
                    <br />
                    {agency.address2}
                    <br />
                    {agency.zipCode}
                    <br />
                    {agency.city}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
};
